import { useMemo } from 'react';
import { Locale, useLocaleContext } from '@storefront/lib-global';
import { useSizeAndWidthContext } from '../context';
import { getShortWidthDescription } from '../utils';

export function useStockAvailabilityInfo() {
  const {
    selectedSize,
    selectedWidth,
    isProductSoldOutOnline,
    isSelectedVariantOutOfStock,
    isSelectedVariantWithNotificationEnabled,
  } = useSizeAndWidthContext();
  const { locale } = useLocaleContext();
  const isNorthAmerica = [Locale.EN_CA, Locale.FR_CA, Locale.EN_US].includes(locale);
  return useMemo(() => {
    if (isProductSoldOutOnline) {
      return {
        message: 'pdp.product.sold.out.online',
        testId: 'productSoldOutOnline',
      };
    }

    if (
      !isProductSoldOutOnline &&
      isSelectedVariantOutOfStock &&
      !isSelectedVariantWithNotificationEnabled &&
      selectedSize &&
      selectedWidth
    ) {
      return {
        message: 'pdp.size.sold.out',
        testId: 'variantSizeSoldOut',
        size: selectedSize,
        width: isNorthAmerica ? ` ${selectedWidth}` : getShortWidthDescription(selectedWidth),
      };
    }

    if (
      !isProductSoldOutOnline &&
      isSelectedVariantOutOfStock &&
      isSelectedVariantWithNotificationEnabled &&
      selectedSize &&
      selectedWidth
    ) {
      return {
        message: 'pdp.out.of.stock.online',
        testId: 'variantOutOfStockOnline',
        size: selectedSize,
        width: isNorthAmerica ? ` ${selectedWidth}` : getShortWidthDescription(selectedWidth),
      };
    }

    return null;
  }, [
    isNorthAmerica,
    isProductSoldOutOnline,
    isSelectedVariantOutOfStock,
    isSelectedVariantWithNotificationEnabled,
    selectedSize,
    selectedWidth,
  ]);
}
